(function () {
  'use strict';

  var script = document.currentScript;
  var localizedRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : (script && script.dataset ? script.dataset.localeRoot : '/');
  var localePrefix = String(localizedRoot || '/').replace(/\/+$/, '');

  if (!localePrefix || localePrefix === '/') return;

  var localePathPattern = /^\/[a-z]{2,3}(?:-[a-z0-9]{2,8})?(?:\/|$)/i;
  var excludedPathPattern = /^\/(?:admin|cdn|challenge|localization|password|services|\.well-known)(?:\/|$)/i;
  var excludedFilesPattern = /^\/(?:agents\.md|robots\.txt|sitemap\.xml|favicon\.ico)(?:$|[?#])/i;

  function localizedHref(rawHref) {
    if (!rawHref || rawHref.charAt(0) === '#' || /^(?:mailto:|tel:|sms:|javascript:|data:|blob:)/i.test(rawHref)) {
      return null;
    }

    var url;
    try {
      url = new URL(rawHref, window.location.href);
    } catch (error) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;
    if (localePathPattern.test(url.pathname)) return null;
    if (excludedPathPattern.test(url.pathname) || excludedFilesPattern.test(url.pathname)) return null;

    url.pathname = localePrefix + (url.pathname === '/' ? '/' : url.pathname);
    return url.pathname + url.search + url.hash;
  }

  function localizeLink(link) {
    if (!link || link.dataset.ybLocaleReady === 'true') return;

    var rawHref = link.getAttribute('href');
    var nextHref = localizedHref(rawHref);
    if (nextHref) link.setAttribute('href', nextHref);
    link.dataset.ybLocaleReady = 'true';
  }

  function localizeLinks(root) {
    if (!root) return;
    if (root.matches && root.matches('a[href]')) localizeLink(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(localizeLink);
  }

  function localizeEventLink(event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('a[href]') : null;
    if (link) localizeLink(link);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { localizeLinks(document); }, { once: true });
  } else {
    localizeLinks(document);
  }

  document.addEventListener('pointerdown', localizeEventLink, true);
  document.addEventListener('shopify:section:load', function (event) { localizeLinks(event.target); });
})();
